'use client';

import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { cn } from '@/lib/utils';

export function SourcesPageSkeleton() {
  return (
    <div className="p-4 lg:p-6">
      {/* Page header skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
        <div className="space-y-1.5">
          <Skeleton className="h-7 w-28" />
          <Skeleton className="h-4 w-64" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-32 rounded-md" />
          <Skeleton className="h-9 w-20 rounded-md" />
          <Skeleton className="h-4 w-36" />
        </div>
      </div>

      {/* KPI strip skeleton (4 cards) */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="border rounded-lg bg-card p-4 space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-7 w-10" />
          </div>
        ))}
      </div>

      {/* Search + filter bar skeleton */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <Skeleton className="h-9 sm:w-64 rounded-md" />
        <Skeleton className="h-8 w-52 rounded-md" />
      </div>

      {/* Table skeleton */}
      <div className="border rounded-lg bg-card">
        <div className="overflow-auto">
          <Table className="table-fixed">
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-[30%]">Source</TableHead>
                <TableHead className="w-[10%]">Status</TableHead>
                <TableHead className="w-[15%]">Last Run</TableHead>
                <TableHead className="w-[10%]">Records</TableHead>
                <TableHead className="w-[25%]">Message</TableHead>
                <TableHead className="w-[10%]"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: 5 }).map((_, i) => (
                <TableRow
                  key={i}
                  className={cn(
                    'border-b border-border/60',
                    i % 2 === 1 ? 'bg-muted/10' : 'bg-background'
                  )}
                >
                  <TableCell className="py-3">
                    <div className="space-y-1.5">
                      <Skeleton className="h-4 w-3/4" />
                      <Skeleton className="h-3 w-1/2" />
                    </div>
                  </TableCell>
                  <TableCell className="py-3">
                    <Skeleton className="h-5 w-14 rounded-full" />
                  </TableCell>
                  <TableCell className="py-3">
                    <Skeleton className="h-4 w-16" />
                  </TableCell>
                  <TableCell className="py-3">
                    <Skeleton className="h-4 w-8" />
                  </TableCell>
                  <TableCell className="py-3">
                    <Skeleton className="h-3 w-3/4" />
                  </TableCell>
                  <TableCell className="py-3">
                    <div className="flex items-center gap-1 justify-end">
                      <Skeleton className="h-7 w-12 rounded-md" />
                      <Skeleton className="h-7 w-12 rounded-md" />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
